import { Badge } from '@folio/components';
import type { DistributionRequestStatus } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { Text } from '@folio/components/ui/text';

interface DistributionRequestStatusBadgeProps {
  /**
   * The status of the distribution request.
   */
  status: DistributionRequestStatus;
}

export function DistributionRequestStatusBadge({ status }: DistributionRequestStatusBadgeProps) {
  const { t } = useTranslation();

  const label = t(`distributionRequests.statuses.${status}`);

  switch (status) {
    case 'APPROVED':
      return <Badge variant="default">{label}</Badge>;
    case 'DENIED':
    case 'REVOKED':
      return <Badge variant="destructive">{label}</Badge>;
    case 'PENDING':
    case 'WAITING_FOR_SIGNATURE':
      return <Badge variant="outline">{label}</Badge>;
    default:
      return (
        <Text inline tone="muted" className="italic">
          Indisponible
        </Text>
      );
  }
}
